import Vue from 'vue';
import {HttpOptions} from 'vue-resource/types/vue_resource';
import {OidcService} from "@/services/oidc-service";
import {TimeEntries} from "@/models/time-entries";
import {TimeEntriesParams} from "@/models/time-entries-params";
import * as config from '@/utils/config'

export class TimeEntriesService extends Vue {
    private oidcService: OidcService = new OidcService();

    options: HttpOptions = {
        headers: {
            'Authorization': '',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
        },
    };

    constructor() {
        super();
    }

    public async getTimeEntries(filters: TimeEntriesParams): Promise<{data: TimeEntries[]; meta: {totalSize: number}}> {
        const access_token =  await this.oidcService.getAccessToken();
        this.options.headers['Authorization'] = 'Bearer ' + access_token;
        return new Promise((resolve, reject) => {
            this.$http.get(config.REDANKA_BE_BASE_URL + '/time-entries' + this.buildParamsForFilters(filters), this.options)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        console.error('Error: ', error);
                        reject(error);
                    });
        });
    }

    public async getTimeEntriesDetails(filters: TimeEntriesParams): Promise<{data: TimeEntries[]; meta: {totalSize: number}}> {
        const access_token =  await this.oidcService.getAccessToken();
        this.options.headers['Authorization'] = 'Bearer ' + access_token;
        return new Promise((resolve, reject) => {
            this.$http.get(config.REDANKA_BE_BASE_URL + '/time-entries/details' + this.buildParamsForFilters(filters), this.options)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        console.error('Error: ', error);
                        reject(error);
                    });
        });
    }

    private buildParamsForFilters(filters: TimeEntriesParams): string {
        let params = '?';
        if (filters.from) {
            params += 'from=' + filters.from.format("YYYY-MM-DD") + '&';
        }
        if (filters.to) {
            params += 'to=' + filters.to.format("YYYY-MM-DD") + '&';
        }
        if (filters.time_entries_id) {
            params += 'teId=' + filters.time_entries_id + '&';
        }
        if (filters.holidayAndLeaves) {
            params += 'paycheck=' + filters.holidayAndLeaves + '&';
        }

        return encodeURI(params.slice(0, -1));
    }

}
